<template>
    <div class="col-lg-5 wizard-box-right wizard-box-progress" :id="'wizard-step-'+this.id">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: ['id'],
    }
</script>
